import styled from 'styled-components'
import colors from '../../../configuration/colors'

const InputHint = styled.div`
  color: ${colors.dove};
  font-size: 11px;
  font-weight: 300;
  white-space: pre-line;
`
export default InputHint



// WEBPACK FOOTER //
// ./src/components/typography/Input/InputHint.js